module.exports = __webpack_public_path__ + "static/media/bg_contact.2706417c.png";